import React from 'react'
import {AnnouncementIcon} from '../../normalizer'

const NotificationAlert = () => (
  <div className="justify-center items-center flex mb-4">
    <AnnouncementIcon className="g-notification__announcement-icon"/>
    <p className="dead-grey small-text-size px-2 vodafone-bold text-center">Anúncio Importante!</p>
  </div>
)

const NotificationItem = (props) => {

  const {
    title, 
    description, 
    onNotificationView,
    id,
    shown: seen,
    important
  } = props

  let handleMouseEnter = undefined
  if(!seen){
    handleMouseEnter = (e) => {
      e.preventDefault()
      onNotificationView(id)
    }
  }   
  
  const containerClassName = ["g-notification__item-container", important && "eee-bg"].join(" ")
  const className= [!seen && 'g-notification__item--to-view primary-bg'].join (' ')
  return (
    <div className={containerClassName}>
      <div className={"g-notification__item"} onMouseEnter={handleMouseEnter}>
        {important && <NotificationAlert/>}
        <div className="vodafone-bold flex mb-4">
          <span className={className}></span>
          <p>{title}</p>
        </div>
        <p className="dead-grey small-title-size vodafone-light font-normal leading-normal">{description}</p>
        <span className="g-notification__line"></span>
      </div>
    </div>
  )
}

export default NotificationItem